import React, { useState, useEffect, useCallback } from 'react';
import { withAppHOC } from '../../../hoc';
import PageHeading from '../../../components/PageHeader/PageHeader';
import OverlayLoader from '../../../components/OverlayLoader/OverlayLoader';
import { Grid, GridItem } from '../../../components/Grid';
import {
  FormContainer,
  Form,
  Fieldset,
  Label,
  MessageBox,
  UpdateButton,
  ResetButton,
  Dropdown,
  NumberInput,
  Legend,
} from '../../../components/FormElements';
import API from '../../../api';
import { API_RESPONSE_TYPES } from '../../../constants';

const AppConfiguration = (props) => {
  const {
    appData: { accessType },
  } = props;
  const [isLoading, setIsLoading] = useState(false);
  const [responseStatus, setResponseStatus] = useState('');
  const [responseMessage, setResponseMessage] = useState('');

  // Login Configuration
  const [twofaStatus, setTwofaStatus] = useState('Active');

  // GST Configuration
  const [gstWalletStatus, setGstWalletStatus] = useState('Active');
  const [nonGstWalletStatus, setNonGstWalletStatus] = useState('Active');
  const [gstInvoiceP2PStatus, setGstInvoiceP2PStatus] = useState('Active');
  const [gstInvoiceP2AStatus, setGstInvoiceP2AStatus] = useState('Active');

  // Recharge Configuration
  const [maxRechargeApiHits, setMaxRechargeApiHits] = useState('');
  const [callbackRechargeProcessingTime, setCallbackRechargeProcessingTime] =
    useState('');
  const [complaintRatioAllowed, setComplaintRatioAllowed] = useState('');
  const [complaintCalculationPeriod, setComplaintCalculationPeriod] =
    useState('');
  const [callbackCalculationPeriod, setCallbackCalculationPeriod] =
    useState('');

  // Payment Gateway Configuration
  const [paymentGatewayMinAmount, setPaymentGatewayMinAmount] = useState('');
  const [paymentGatewayMaxAmount, setPaymentGatewayMaxAmount] = useState('');

  // Wallet Configuration
  const [complaintHoldDays, setComplaintHoldDays] = useState('');
  const [sellerAmountHoldPercentage, setSellerAmountHoldPercentage] =
    useState('');
  const [timeBetweenRedeem, setTimeBetweenRedeem] = useState('');
  const [minAutoWalletTransferAmount, setMinAutoWalletTransferAmount] =
    useState('');
  const [timeBetweenAutoWalletTransfer, setTimeBetweenAutoWalletTransfer] =
    useState('');
  const [autoWalletTransferStatus, setAutoWalletTransferStatus] =
    useState('Active');
  const [timeBetweenComplaints, setTimeBetweenComplaints] = useState('');
  const [minimumTopupAmountLimit, setMinimumTopupAmountLimit] = useState('');
  const [maximumTopupAmountLimit, setMaximumTopupAmountLimit] = useState('');
  const [switchingMinimumAmount, setSwitchingMinimumAmount] = useState('');
  const [switchingMaximumAmount, setSwitchingMaximumAmount] = useState('');
  const [minimumRedeemAmountLimit, setMinimumRedeemAmountLimit] = useState('');
  const [maximumRedeemAmountLimit, setMaximumRedeemAmountLimit] = useState('');


  // Seller Configuration
  const [sellersMaxAllowedApis, setSellersMaxAllowedApis] = useState('');
  const [sellersAPIEditStatus, setSellersAPIEditStatus] = useState('Active');
  const [sellersAPIDeleteStatus, setSellersAPIDeleteStatus] =
    useState('Active');
  const [sellersMarginEditStatus, setSellersMarginEditStatus] =
    useState('Active');
  const [sellersMarginDeleteStatus, setSellersMarginDeleteStatus] =
    useState('Active');
  const [sellersMarginUserCountStatus, setSellersMarginUserCountStatus] =
    useState('');

  // Payout Configuration
  const [bankVerificationCharges, setBankVerificationCharges] = useState('');
  const [withdrawCharges, setWithdrawCharges] = useState('');

  // User Complaint Settings
  const [complaintsAllowedTime, setComplaintsAllowedTime] = useState('');
  const [complaintsAllowedCount, setComplaintsAllowedCount] = useState('');

  // User Api Disable Settings
  const [apiDisableforComplaintTime, setApiDisableforComplaintTime] =
    useState('');
  const [apiDisableforPendingTime, setApiDisableforPendingTime] = useState('');

  const [originalFormData, setOriginalFormData] = useState({});

  const resetResponseData = () => {
    setIsLoading(false);
    setResponseStatus('');
    setResponseMessage('');
  };

  const resetForm = () => {
    const {
      // Login Configuration
      twofaStatus,

      // GST Configuration
      gstWalletStatus,
      nonGstWalletStatus,
      gstInvoiceP2PStatus,
      gstInvoiceP2AStatus,

      // Recharge Configuration
      maxRechargeApiHits,
      callbackRechargeProcessingTime,
      complaintRatioAllowed,
      complaintCalculationPeriod,
      callbackCalculationPeriod,

      // Payment Gateway Configuration
      paymentGatewayMinAmount,
      paymentGatewayMaxAmount,

      // Wallet Configuration
      complaintHoldDays,
      sellerAmountHoldPercentage,
      timeBetweenRedeem,
      minAutoWalletTransferAmount,
      timeBetweenAutoWalletTransfer,
      autoWalletTransferStatus,
      timeBetweenComplaints,
      minimumTopupAmountLimit,
      maximumTopupAmountLimit,
      switchingMinimumAmount,
      switchingMaximumAmount,
      minimumRedeemAmountLimit,
      maximumRedeemAmountLimit,

      // Seller Configuration
      sellersMaxAllowedApis,
      sellersAPIEditStatus,
      sellersAPIDeleteStatus,
      sellersMarginEditStatus,
      sellersMarginDeleteStatus,
      sellersMarginUserCountStatus,

      // Payout Configuration
      bankVerificationCharges,
      withdrawCharges,

      // User Complaint Settings
      complaintsAllowedTime,
      complaintsAllowedCount,

      // User Api Disable Settings
      apiDisableforComplaintTime,
      apiDisableforPendingTime,
    } = originalFormData;

    // Login Configuration
    setTwofaStatus(twofaStatus);

    // GST Configuration
    setGstWalletStatus(gstWalletStatus);
    setNonGstWalletStatus(nonGstWalletStatus);
    setGstInvoiceP2PStatus(gstInvoiceP2PStatus);
    setGstInvoiceP2AStatus(gstInvoiceP2AStatus);

    // Recharge Configuration
    setMaxRechargeApiHits(maxRechargeApiHits);
    setCallbackRechargeProcessingTime(callbackRechargeProcessingTime);
    setComplaintRatioAllowed(complaintRatioAllowed);
    setComplaintCalculationPeriod(complaintCalculationPeriod);
    setCallbackCalculationPeriod(callbackCalculationPeriod);

    // Payment Gateway Configuration
    setPaymentGatewayMinAmount(paymentGatewayMinAmount);
    setPaymentGatewayMaxAmount(paymentGatewayMaxAmount);

    // Wallet Configuration
    setComplaintHoldDays(complaintHoldDays);
    setSellerAmountHoldPercentage(sellerAmountHoldPercentage);
    setTimeBetweenRedeem(timeBetweenRedeem);
    setMinimumTopupAmountLimit(minimumTopupAmountLimit);
    setMaximumTopupAmountLimit(maximumTopupAmountLimit);
    setSwitchingMinimumAmount(switchingMinimumAmount);
    setSwitchingMinimumAmount(switchingMaximumAmount);
    setMinimumRedeemAmountLimit(minimumRedeemAmountLimit);
    setMaximumRedeemAmountLimit(maximumRedeemAmountLimit);
    setMinAutoWalletTransferAmount(minAutoWalletTransferAmount);
    setTimeBetweenAutoWalletTransfer(timeBetweenAutoWalletTransfer);
    setAutoWalletTransferStatus(autoWalletTransferStatus);
    setTimeBetweenComplaints(timeBetweenComplaints);
    setMinimumTopupAmountLimit(minimumTopupAmountLimit);
    setMaximumTopupAmountLimit(maximumTopupAmountLimit);

    // Seller Configuration
    setSellersMaxAllowedApis(sellersMaxAllowedApis);
    setSellersAPIEditStatus(sellersAPIEditStatus);
    setSellersAPIDeleteStatus(sellersAPIDeleteStatus);
    setSellersMarginEditStatus(sellersMarginEditStatus);
    setSellersMarginDeleteStatus(sellersMarginDeleteStatus);
    setSellersMarginUserCountStatus(sellersMarginUserCountStatus);

    // Payout Configuration
    setBankVerificationCharges(bankVerificationCharges);
    setWithdrawCharges(withdrawCharges);

    // User Complaint Settings
    setComplaintsAllowedTime(complaintsAllowedTime);
    setComplaintsAllowedCount(complaintsAllowedCount);

    // User Api Disable Settings
    setApiDisableforComplaintTime(apiDisableforComplaintTime);
    setApiDisableforPendingTime(apiDisableforPendingTime);
  };

  const readData = useCallback(() => {
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    API.get(`/configurations/app-configuration`)
      .then((response) => {
        const { status, message, data } = response.data;
        if (status === API_RESPONSE_TYPES.FAILED) {
          setResponseStatus(status);
          setResponseMessage(message);
        } else {
          const {
            // Login Configuration
            twofaStatus,

            // GST Configuration
            gstWalletStatus,
            nonGstWalletStatus,
            gstInvoiceP2PStatus,
            gstInvoiceP2AStatus,

            // Recharge Configuration
            maxRechargeApiHits,
            callbackRechargeProcessingTime,
            complaintRatioAllowed,
            complaintCalculationPeriod,
            callbackCalculationPeriod,

            // Payment Gateway Configuration
            paymentGatewayMinAmount,
            paymentGatewayMaxAmount,

            // Wallet Configuration
            complaintHoldDays,
            sellerAmountHoldPercentage,
            timeBetweenRedeem,
            minAutoWalletTransferAmount,
            timeBetweenAutoWalletTransfer,
            autoWalletTransferStatus,
            timeBetweenComplaints,
            minimumTopupAmountLimit,
            maximumTopupAmountLimit,
            switchingMinimumAmount,
            switchingMaximumAmount,
            minimumRedeemAmountLimit,
            maximumRedeemAmountLimit,

            // Seller Configuration
            sellersMaxAllowedApis,
            sellersAPIEditStatus,
            sellersAPIDeleteStatus,
            sellersMarginEditStatus,
            sellersMarginDeleteStatus,
            sellersMarginUserCountStatus,

            // Payout Configuration
            bankVerificationCharges,
            withdrawCharges,

            // User Complaint Settings
            complaintsAllowedTime,
            complaintsAllowedCount,

            // User Api Disable Settings
            apiDisableforComplaintTime,
            apiDisableforPendingTime,
          } = data;
          // Login Configuration
          setTwofaStatus(twofaStatus);

          // GST Configuration
          setGstWalletStatus(gstWalletStatus);
          setNonGstWalletStatus(nonGstWalletStatus);
          setGstInvoiceP2PStatus(gstInvoiceP2PStatus);
          setGstInvoiceP2AStatus(gstInvoiceP2AStatus);

          // Recharge Configuration
          setMaxRechargeApiHits(maxRechargeApiHits);
          setCallbackRechargeProcessingTime(callbackRechargeProcessingTime);
          setComplaintRatioAllowed(complaintRatioAllowed);
          setComplaintCalculationPeriod(complaintCalculationPeriod);
          setCallbackCalculationPeriod(callbackCalculationPeriod);

          // Payment Gateway Configuration
          setPaymentGatewayMinAmount(paymentGatewayMinAmount);
          setPaymentGatewayMaxAmount(paymentGatewayMaxAmount);

          // Wallet Configuration
          setComplaintHoldDays(complaintHoldDays);
          setSellerAmountHoldPercentage(sellerAmountHoldPercentage);
          setTimeBetweenRedeem(timeBetweenRedeem);
          setMinAutoWalletTransferAmount(minAutoWalletTransferAmount);
          setTimeBetweenAutoWalletTransfer(timeBetweenAutoWalletTransfer);
          setAutoWalletTransferStatus(autoWalletTransferStatus);
          setTimeBetweenComplaints(timeBetweenComplaints);
          setMinimumTopupAmountLimit(minimumTopupAmountLimit);
          setMaximumTopupAmountLimit(maximumTopupAmountLimit);
          setSwitchingMinimumAmount(switchingMinimumAmount);
          setSwitchingMaximumAmount(switchingMaximumAmount);
          setMinimumRedeemAmountLimit(minimumRedeemAmountLimit);
          setMaximumRedeemAmountLimit(maximumRedeemAmountLimit);

          // Seller Configuration
          setSellersMaxAllowedApis(sellersMaxAllowedApis);
          setSellersAPIEditStatus(sellersAPIEditStatus);
          setSellersAPIDeleteStatus(sellersAPIDeleteStatus);
          setSellersMarginEditStatus(sellersMarginEditStatus);
          setSellersMarginDeleteStatus(sellersMarginDeleteStatus);
          setSellersMarginUserCountStatus(sellersMarginUserCountStatus);

          // Payout Configuration
          setBankVerificationCharges(bankVerificationCharges);
          setWithdrawCharges(withdrawCharges);

          // User Complaint Settings
          setComplaintsAllowedTime(complaintsAllowedTime);
          setComplaintsAllowedCount(complaintsAllowedCount);

          // User Api Disable Settings
          setApiDisableforComplaintTime(apiDisableforComplaintTime);
          setApiDisableforPendingTime(apiDisableforPendingTime);

          setOriginalFormData({
            // Login Configuration
            twofaStatus,

            // GST Configuration
            gstWalletStatus,
            nonGstWalletStatus,
            gstInvoiceP2PStatus,
            gstInvoiceP2AStatus,

            // Recharge Configuration
            maxRechargeApiHits,
            callbackRechargeProcessingTime,
            complaintRatioAllowed,
            complaintCalculationPeriod,
            callbackCalculationPeriod,

            // Payment Gateway Configuration
            paymentGatewayMinAmount,
            paymentGatewayMaxAmount,

            // Wallet Configuration
            complaintHoldDays,
            sellerAmountHoldPercentage,
            timeBetweenRedeem,
            minAutoWalletTransferAmount,
            timeBetweenAutoWalletTransfer,
            autoWalletTransferStatus,
            timeBetweenComplaints,
            minimumTopupAmountLimit,
            maximumTopupAmountLimit,
            switchingMinimumAmount,
            switchingMaximumAmount,
            minimumRedeemAmountLimit,
            maximumRedeemAmountLimit,

            // Seller Configuration
            sellersMaxAllowedApis,
            sellersAPIEditStatus,
            sellersAPIDeleteStatus,
            sellersMarginEditStatus,
            sellersMarginDeleteStatus,
            sellersMarginUserCountStatus,

            // Payout Configuration
            bankVerificationCharges,
            withdrawCharges,

            // User Complaint Settings
            complaintsAllowedTime,
            complaintsAllowedCount,

            // User Api Disable Settings
            apiDisableforComplaintTime,
            apiDisableforPendingTime,
          });
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const onSubmit = (e) => {
    e.preventDefault();
    setIsLoading(true);
    setResponseStatus('');
    setResponseMessage('');
    const formData = {
      // Login Configuration
      twofaStatus,

      // GST Configuration
      gstWalletStatus,
      nonGstWalletStatus,
      gstInvoiceP2PStatus,
      gstInvoiceP2AStatus,

      // Recharge Configuration
      maxRechargeApiHits,
      callbackRechargeProcessingTime,
      complaintRatioAllowed: ['V1'].includes(accessType)
        ? '100'
        : complaintRatioAllowed,
      complaintCalculationPeriod,
      callbackCalculationPeriod,

      // Payment Gateway Configuration
      paymentGatewayMinAmount: ['V1'].includes(accessType)
        ? '0'
        : paymentGatewayMinAmount,
      paymentGatewayMaxAmount: ['V1'].includes(accessType)
        ? '0'
        : paymentGatewayMaxAmount,

      // Wallet Configuration
      complaintHoldDays,
      sellerAmountHoldPercentage,
      timeBetweenRedeem,
      minAutoWalletTransferAmount: ['V1'].includes(accessType)
        ? '0'
        : minAutoWalletTransferAmount,
      timeBetweenAutoWalletTransfer: ['V1'].includes(accessType)
        ? '0'
        : timeBetweenAutoWalletTransfer,
      autoWalletTransferStatus: ['V1'].includes(accessType)
        ? 'Inactive'
        : autoWalletTransferStatus,
      timeBetweenComplaints,
      minimumTopupAmountLimit,
      maximumTopupAmountLimit,
      switchingMinimumAmount,
      switchingMaximumAmount,
      minimumRedeemAmountLimit,
      maximumRedeemAmountLimit,

      // Seller Configuration
      sellersMaxAllowedApis,
      sellersAPIEditStatus,
      sellersAPIDeleteStatus,
      sellersMarginEditStatus,
      sellersMarginDeleteStatus,
      sellersMarginUserCountStatus,

      // Payout Configuration
      bankVerificationCharges,
      withdrawCharges,

      // User Complaint Settings
      complaintsAllowedTime,
      complaintsAllowedCount,

      // User Api Disable Settings
      apiDisableforComplaintTime,
      apiDisableforPendingTime,
    };
    API.put(`/configurations/app-configuration`, formData)
      .then((response) => {
        const { status, message } = response.data;
        setResponseStatus(status);
        setResponseMessage(message);
        if (status === API_RESPONSE_TYPES.SUCCESS) {
          setOriginalFormData(formData);
          setTimeout(() => {
            resetResponseData();
          }, 3000);
        }
      })
      .catch((error) => {
        setResponseStatus(API_RESPONSE_TYPES.FAILED);
        setResponseMessage(error.message);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  useEffect(() => {
    readData();
  }, [readData]);

  return (
    <>
      <PageHeading {...props} />
      <FormContainer>
        <Form method="POST" action="#" onSubmit={onSubmit}>
          {/* Login Configuration */}
          <Fieldset forLegend display="block">
            <Legend>Login Configuration</Legend>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label>2FA Status</Label>
                  <Dropdown
                    value={twofaStatus}
                    onChange={setTwofaStatus}
                    placeholder="Please select 2FA status"
                    disabled={isLoading}
                    options={[
                      { title: 'Active', value: 'Active' },
                      { title: 'Inactive', value: 'Inactive' },
                    ]}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          {/* GST Configuration */}
          <Fieldset forLegend display="block">
            <Legend>GST Configuration</Legend>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label>GST Wallet Status</Label>
                  <Dropdown
                    value={gstWalletStatus}
                    onChange={setGstWalletStatus}
                    placeholder="Please select gst wallet status"
                    disabled={isLoading}
                    options={[
                      { title: 'Active', value: 'Active' },
                      { title: 'Inactive', value: 'Inactive' },
                    ]}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Non-GST Wallet Status</Label>
                  <Dropdown
                    value={nonGstWalletStatus}
                    onChange={setNonGstWalletStatus}
                    placeholder="Please select non gst wallet status"
                    disabled={isLoading}
                    options={[
                      { title: 'Active', value: 'Active' },
                      { title: 'Inactive', value: 'Inactive' },
                    ]}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>GST Invoice P2P Status</Label>
                  <Dropdown
                    value={gstInvoiceP2PStatus}
                    onChange={setGstInvoiceP2PStatus}
                    placeholder="Please select gst invoice P2P status"
                    disabled={isLoading}
                    options={[
                      { title: 'Active', value: 'Active' },
                      { title: 'Inactive', value: 'Inactive' },
                    ]}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>GST Invoice P2A Status</Label>
                  <Dropdown
                    value={gstInvoiceP2AStatus}
                    onChange={setGstInvoiceP2AStatus}
                    placeholder="Please select gst invoice P2A status"
                    disabled={isLoading}
                    options={[
                      { title: 'Active', value: 'Active' },
                      { title: 'Inactive', value: 'Inactive' },
                    ]}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          {/* Recharge Configuration */}
          <Fieldset forLegend display="block">
            <Legend>Recharge Configuration</Legend>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label>Max Recharge APIS Hits</Label>
                  <NumberInput
                    value={maxRechargeApiHits}
                    onChange={setMaxRechargeApiHits}
                    placeholder="Please enter seller max allowed apis"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Callback Recharge Processing Time</Label>
                  <NumberInput
                    value={callbackRechargeProcessingTime}
                    onChange={setCallbackRechargeProcessingTime}
                    placeholder="Please enter callback recharge processing time"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              {!['V1'].includes(accessType) && (
                <GridItem>
                  <Fieldset>
                    <Label>Complaint Ratio Allowed</Label>
                    <NumberInput
                      value={complaintRatioAllowed}
                      onChange={setComplaintRatioAllowed}
                      placeholder="Please enter complaint ratio allowed"
                      disabled={isLoading}
                    />
                  </Fieldset>
                </GridItem>
              )}
              <GridItem>
                <Fieldset>
                  <Label>Complaint Calculation Period (Days)</Label>
                  <NumberInput
                    value={complaintCalculationPeriod}
                    onChange={setComplaintCalculationPeriod}
                    placeholder="Please enter complaint calculation period"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label>Callback Calculation Period (Days)</Label>
                  <NumberInput
                    value={callbackCalculationPeriod}
                    onChange={setCallbackCalculationPeriod}
                    placeholder="Please enter callback calculation period"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          {/* Payment Gateway Configuration */}
          {!['V1'].includes(accessType) && (
            <Fieldset forLegend display="block">
              <Legend>Payment Gateway Configuration</Legend>
              <Grid
                columns={
                  'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
                }
              >
                <GridItem>
                  <Fieldset>
                    <Label>Payment Gateway Min Amount</Label>
                    <NumberInput
                      value={paymentGatewayMinAmount}
                      onChange={setPaymentGatewayMinAmount}
                      placeholder="Please enter payment gateway min amount"
                      disabled={isLoading}
                    />
                  </Fieldset>
                </GridItem>
                <GridItem>
                  <Fieldset>
                    <Label>Payment Gateway Max Amount</Label>
                    <NumberInput
                      value={paymentGatewayMaxAmount}
                      onChange={setPaymentGatewayMaxAmount}
                      placeholder="Please enter payment gateway max amount"
                      disabled={isLoading}
                    />
                  </Fieldset>
                </GridItem>
              </Grid>
            </Fieldset>
          )}
          {/* Wallet Configuration */}
          <Fieldset forLegend display="block">
            <Legend>Wallet Configuration</Legend>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Label>Complaint Hold Days</Label>
                <NumberInput
                  value={complaintHoldDays}
                  onChange={setComplaintHoldDays}
                  placeholder="Please enter complaint hold days"
                  disabled={isLoading}
                />
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Seller Amount Hold Percentage</Label>
                  <NumberInput
                    value={sellerAmountHoldPercentage}
                    onChange={setSellerAmountHoldPercentage}
                    placeholder="Please enter seller amount hold percentage"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Time Between Redeem Requests (Minutes)</Label>
                  <NumberInput
                    value={timeBetweenRedeem}
                    onChange={setTimeBetweenRedeem}
                    placeholder="Please enter time between redeem"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Time Between Complaints (Minutes)</Label>
                  <NumberInput
                    value={timeBetweenComplaints}
                    onChange={setTimeBetweenComplaints}
                    placeholder="Please enter time between complaints"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          <Fieldset forLegend display="block">
            <Legend>Redeem Configuration</Legend>
            <Grid
              columns="calc(50% - 10px) calc(50% - 10px)"
            >
              <GridItem>
                <Label>Minimum Redeem Amount</Label>
                <NumberInput
                  value={minimumRedeemAmountLimit}
                  onChange={setMinimumRedeemAmountLimit}
                  placeholder="Please enter Minimum Redeem Amount"
                  disabled={isLoading}
                />
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Maximum Redeem Amount</Label>
                  <NumberInput
                    value={maximumRedeemAmountLimit}
                    onChange={setMaximumRedeemAmountLimit}
                    placeholder="Please enter Maximum Redeem amount"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid
              columns="calc(50% - 10px) calc(50% - 10px)"
            >
              <GridItem>
                <Label>Minimum Swithcing Amount</Label>
                <NumberInput
                  value={switchingMinimumAmount}
                  onChange={setSwitchingMinimumAmount}
                  placeholder="Please enter Switching Minimum Amount"
                  disabled={isLoading}
                />
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>maximum Swithcing Amount</Label>
                  <NumberInput
                    value={switchingMaximumAmount}
                    onChange={setSwitchingMaximumAmount}
                    placeholder="Please enter Switching Maximum Amount"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          <Fieldset forLegend display="block">
            <Legend>Wallet Topup Configuration</Legend>
            <Grid
              columns="calc(50% - 10px) calc(50% - 10px)"
            >
              <GridItem>
                <Label>minimum Wallet Topup</Label>
                <NumberInput
                  value={minimumTopupAmountLimit}
                  onChange={setMinimumTopupAmountLimit}
                  placeholder="Please enter Minimum Topup Amount"
                  disabled={isLoading}
                />
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>maximum Wallet Topup</Label>
                  <NumberInput
                    value={maximumTopupAmountLimit}
                    onChange={setMaximumTopupAmountLimit}
                    placeholder="Please enter Maximum Topup amount"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            {!['V1'].includes(accessType) && (
              <Grid
                columns={
                  'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
                }
              >
                <GridItem>
                  <Fieldset>
                    <Label>Auto Wallet Transfer Status</Label>
                    <Dropdown
                      value={autoWalletTransferStatus}
                      onChange={setAutoWalletTransferStatus}
                      placeholder="Please select auto wallet transfer status"
                      disabled={isLoading}
                      options={[
                        { title: 'Active', value: 'Active' },
                        { title: 'Inactive', value: 'Inactive' },
                      ]}
                    />
                  </Fieldset>
                </GridItem>
                <GridItem>
                  <Fieldset>
                    <Label>Time Between Auto Wallet Transfer (Minutes)</Label>
                    <NumberInput
                      value={timeBetweenAutoWalletTransfer}
                      onChange={setTimeBetweenAutoWalletTransfer}
                      placeholder="Please enter time between auto wallet transfers"
                      disabled={isLoading}
                    />
                  </Fieldset>
                </GridItem>
                <GridItem>
                  <Label>Min Auto Wallet Transfer Amount</Label>
                  <NumberInput
                    value={minAutoWalletTransferAmount}
                    onChange={setMinAutoWalletTransferAmount}
                    placeholder="Please enter min auto wallet transfer amount"
                    disabled={isLoading}
                  />
                </GridItem>
              </Grid>
            )}
          </Fieldset>
          {/* Seller Configuration */}
          <Fieldset forLegend display="block">
            <Legend>Seller Configuration</Legend>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label>Can Seller Edit API?</Label>
                  <Dropdown
                    value={sellersAPIEditStatus}
                    onChange={setSellersAPIEditStatus}
                    placeholder="Please select if sellers can edit api"
                    disabled={isLoading}
                    options={[
                      { title: 'Yes', value: 'Yes' },
                      { title: 'No', value: 'No' },
                    ]}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Can Seller Delete API?</Label>
                  <Dropdown
                    value={sellersAPIDeleteStatus}
                    onChange={setSellersAPIDeleteStatus}
                    placeholder="Please select if sellers can delete api"
                    disabled={isLoading}
                    options={[
                      { title: 'Yes', value: 'Yes' },
                      { title: 'No', value: 'No' },
                    ]}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Can Seller Edit Margin?</Label>
                  <Dropdown
                    value={sellersMarginEditStatus}
                    onChange={setSellersMarginEditStatus}
                    placeholder="Please select if sellers can edit margin"
                    disabled={isLoading}
                    options={[
                      { title: 'Yes', value: 'Yes' },
                      { title: 'No', value: 'No' },
                    ]}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Can Seller Delete Margin?</Label>
                  <Dropdown
                    value={sellersMarginDeleteStatus}
                    onChange={setSellersMarginDeleteStatus}
                    placeholder="Please select if sellers can delete margin"
                    disabled={isLoading}
                    options={[
                      { title: 'Yes', value: 'Yes' },
                      { title: 'No', value: 'No' },
                    ]}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Label>Seller Max Allowed APIS</Label>
                <NumberInput
                  value={sellersMaxAllowedApis}
                  onChange={setSellersMaxAllowedApis}
                  placeholder="Please enter seller max allowed apis"
                  disabled={isLoading}
                />
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Seller Margin Disable User Count</Label>
                  <NumberInput
                    value={sellersMarginUserCountStatus}
                    onChange={setSellersMarginUserCountStatus}
                    placeholder="Please enter seller margin user disable count"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          {/* Payout Configuration */}
          <Fieldset forLegend display="block">
            <Legend>Payout Configuration</Legend>
            <Grid
              columns={
                'calc(25% - 15px) calc(25% - 15px) calc(25% - 15px) calc(25% - 15px)'
              }
            >
              <GridItem>
                <Fieldset>
                  <Label>Bank Verification Charges</Label>
                  <NumberInput
                    value={bankVerificationCharges}
                    onChange={setBankVerificationCharges}
                    placeholder="Please enter bank verification charges"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
              <GridItem>
                <Fieldset>
                  <Label>Withdraw Charges</Label>
                  <NumberInput
                    value={withdrawCharges}
                    onChange={setWithdrawCharges}
                    placeholder="Please enter withdraw charges"
                    disabled={isLoading}
                  />
                </Fieldset>
              </GridItem>
            </Grid>
          </Fieldset>
          {/* User Complaint Settings */}
          <Fieldset forLegend display="block">
            <Legend>User Complaint Settings</Legend>
            <Fieldset>
              <Label>Complaints Allowed Time</Label>
              <NumberInput
                value={complaintsAllowedTime}
                onChange={setComplaintsAllowedTime}
                placeholder="Please enter complaints allowed time"
                disabled={isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label>Complaints Allowed Count</Label>
              <NumberInput
                value={complaintsAllowedCount}
                onChange={setComplaintsAllowedCount}
                placeholder="Please enter complaints allowed count"
                disabled={isLoading}
              />
            </Fieldset>
          </Fieldset>
          {/* User API Disable Settings */}
          <Fieldset forLegend display="block">
            <Legend>User API Disable Settings</Legend>
            <Fieldset>
              <Label>API Disable for Complaint Time</Label>
              <NumberInput
                value={apiDisableforComplaintTime}
                onChange={setApiDisableforComplaintTime}
                placeholder="Please enter api disable for complaint time"
                disabled={isLoading}
              />
            </Fieldset>
            <Fieldset>
              <Label>API Disable for Pending Time</Label>
              <NumberInput
                value={apiDisableforPendingTime}
                onChange={setApiDisableforPendingTime}
                placeholder="Please enter api disable for pending time"
                disabled={isLoading}
              />
            </Fieldset>
          </Fieldset>
          {responseStatus && (
            <Fieldset>
              <MessageBox status={responseStatus} message={responseMessage} />
            </Fieldset>
          )}
          <Fieldset>
            <UpdateButton disabled={isLoading} type="submit">
              Update
            </UpdateButton>
            <ResetButton disabled={isLoading} type="button" onClick={resetForm}>
              Reset
            </ResetButton>
          </Fieldset>
        </Form>
        <OverlayLoader showLoader={isLoading} />
      </FormContainer>
    </>
  );
};

export default withAppHOC(AppConfiguration);
